<template>
    <div>
        <div class="mt-10">
            <v-container>
                <v-expansion-panels :value="0">
                    <v-expansion-panel class="rounded-xl">
                        <v-expansion-panel-header>
                            <span class="subtitle-1 font-weight-medium" > {{ $t(question.question) }} </span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="body-2">
                            <span> {{ link_things[0] }} </span>
                            <a v-if="link_things[1]" :href="link_things[3]" target="_new"> {{ link_things[2] }} </a>
                            <span v-if="link_things[1]"> {{ link_things[4] }} </span>
                            
                            <v-spacer v-if="link_things[5]" cols='12' class="py-3"></v-spacer>
                            <v-divider v-if="link_things[5]" ></v-divider>
                            <v-spacer v-if="link_things[5]" cols='12' class="py-3"></v-spacer>
                            <v-img v-if="link_things[5]" width="560" height="315" align="center" cols="4" :src="link_things[6]"></v-img>
                            
                            <v-spacer v-if="link_things[7]" cols='12' class="py-3"></v-spacer>
                            <v-divider v-if="link_things[7]" ></v-divider>
                            <v-spacer v-if="link_things[7]" cols='12' class="py-3"></v-spacer>
                            <iframe v-if="link_things[7]" width="560" height="315" align="center" cols="4" :src="link_things[8]" title="YouTube video player" frameborder="0" allowfullscreen></iframe>
                        
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-container>
        </div>
        <div>
            <v-container>
                <v-row>
                    <v-col v-for="button in question.buttons" :key="(parseInt(button.text.at(-1)) - 1)" @click="confirm_and_evaluate(parseInt(button.text.at(-1)) - 1)" cols="6">
                        <v-card class="rounded-pill pt-2" color="#106B9E" dark height="40" align="center" hover> {{ $t(button.text) }} </v-card>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col cols="6" @click="$emit('go_back')">
                        <v-card class="rounded-pill pt-2" color="#073955" dark height="40" align="center" hover> <v-icon> mdi-undo </v-icon> {{ $t('go_back') }} </v-card>
                    </v-col>
                    <v-col cols="6" @click="$emit('restart')">
                        <v-card class="rounded-pill pt-2" color="#073955" dark height="40" align="center" hover> <v-icon>mdi-restart</v-icon> {{ $t('restart') }} </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        
    </div>

</template>

<script>
import i18n from '../i18n'
import { extract_links_images_videos } from '../get_link_image_video'
export default {
    name: 'questionTemplate',
    props: {
        question: Object,
    },
    data: () => ({
        answer: null,
        link_things: null,
    }),
    methods: {
        confirm_and_evaluate(id) {
            this.answer = this.question.buttons[id].text
            this.$emit('button_pressed', [this.question.buttons[id].add, this.question.buttons[id].remove, this.answer])
        },

    },
    created() {
        this.link_things = extract_links_images_videos(this.$t(this.question.extra_info))
    },
    beforeUpdate() {
        this.link_things = extract_links_images_videos(this.$t(this.question.extra_info))
    },
    watch: {
        question: function() {
        this.link_things = extract_links_images_videos(this.$t(this.question.extra_info))
        },
        language_switch_detection: function() {
            console.log('test')
            console.log(this.language_switch_detection)
        }
    }




}

</script>


